export default __webpack_public_path__ + "static/assets/noDataPattern.9ae19dad.svg";